export const MONTESSORI_BASE_PATH = "/montessori";

// Each app is a Vite build served statically from /public/montessori/<folder>/
// (see scripts/build-montessori.js). Links must be full page loads, not router navigation.
export const montessoriApps = [
  {
    slug: "relogio-montessori",
    url: `${MONTESSORI_BASE_PATH}/relogio-montessori/`,
    emoji: "🕰️",
    accent: "#6f9a6b",
    soft: "#e6efdf",
    titleKey: "montessori.apps.relogio.title",
    descriptionKey: "montessori.apps.relogio.description",
    tagKey: "montessori.apps.relogio.tag",
    featureKeys: [
      "montessori.apps.relogio.features.clock",
      "montessori.apps.relogio.features.routine",
      "montessori.apps.relogio.features.adult",
    ],
  },
  {
    slug: "lista-montessori",
    url: `${MONTESSORI_BASE_PATH}/lista-montessori/`,
    emoji: "🛒",
    accent: "#c8714b",
    soft: "#f6e2d6",
    titleKey: "montessori.apps.lista.title",
    descriptionKey: "montessori.apps.lista.description",
    tagKey: "montessori.apps.lista.tag",
    featureKeys: [
      "montessori.apps.lista.features.pictures",
      "montessori.apps.lista.features.voice",
      "montessori.apps.lista.features.market",
    ],
  },
];
